import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, euro } from "@/lib/api";
import { Download } from "lucide-react";

export const STATUS_LABELS = {
  recue: "Reçue", confirmee: "Confirmée", appelee: "Appelée", preparee: "Préparée",
  livree: "Livrée", retiree: "Retirée", annulee: "Annulée",
};
export const statusColor = (s) => ({
  recue: "bg-brand-gold/20 text-[#9a6a1f]", confirmee: "bg-brand-green/10 text-brand-green",
  appelee: "bg-blue-100 text-blue-700", preparee: "bg-purple-100 text-purple-700",
  livree: "bg-green-100 text-green-700", retiree: "bg-green-100 text-green-700",
  annulee: "bg-brand-alert/10 text-brand-alert",
}[s] || "bg-brand-sage text-brand-green");

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/admin/orders").then(({ data }) => setOrders(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const exportCsv = async () => {
    const { data } = await api.get("/admin/export/orders.csv", { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([data]));
    const a = document.createElement("a"); a.href = url; a.download = "commandes.csv"; a.click();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <h1 className="font-serif text-3xl font-bold text-brand-green">Réservations</h1>
        <button data-testid="export-csv" onClick={exportCsv} className="inline-flex items-center gap-2 rounded-lg bg-brand-green text-white px-4 py-2 text-sm"><Download className="w-4 h-4" /> Export CSV</button>
      </div>
      <div className="bg-white rounded-xl border border-brand-green/10 overflow-x-auto">
        <table className="w-full text-sm" data-testid="orders-table">
          <thead className="bg-brand-sage text-brand-green/70 text-xs uppercase">
            <tr>{["Réf", "Date", "Client", "Téléphone", "Gamme", "Mode", "Montant", "Statut"].map((h) => <th key={h} className="text-left p-3">{h}</th>)}</tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-t border-brand-green/5 hover:bg-brand-sage/40">
                <td className="p-3"><Link to={`/admin/commandes/${o.id}`} data-testid={`order-row-${o.ref}`} className="font-semibold text-brand-green underline">{o.ref}</Link></td>
                <td className="p-3 text-brand-green/60">{(o.created_at || "").slice(0, 10)}</td>
                <td className="p-3">{o.customer?.name}</td>
                <td className="p-3 text-brand-green/60">{o.customer?.phone}</td>
                <td className="p-3">{o.items?.[0]?.name}</td>
                <td className="p-3">{o.mode}</td>
                <td className="p-3 font-semibold">{euro(o.product_total_ttc)}</td>
                <td className="p-3"><span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${statusColor(o.status)}`}>{STATUS_LABELS[o.status]}</span></td>
              </tr>
            ))}
            {orders.length === 0 && <tr><td colSpan={8} className="p-8 text-center text-brand-green/50">Aucune réservation</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
